@let fixtureListGrid = grid$ | async;
@if (isTouchActionSupported) {
    <div class="event-list" [ngClass]="{ 'calendar-info-wrapper': calendarIntervals?.length }" (swiperight)="goBack()">
        <ng-container *ngTemplateOutlet="componentTemplate" />
    </div>
}
@if (!isTouchActionSupported) {
    <div class="event-list" [ngClass]="{ 'calendar-info-wrapper': calendarIntervals?.length }">
        <ng-container *ngTemplateOutlet="componentTemplate" />
    </div>
}

<ng-template #componentTemplate>
    @if (calendarIntervals?.length) {
        <ds-tabs-group
            class="calendar-tab list"
            msThemedTabs
            indicator="underline"
            size="small"
            variant="vertical"
            [themedInverse]="themeInverseIndicator"
            [fullWidthTabs]="false"
            [activeTab]="activeCalender"
            (activeTabChanged)="onSelectedTab($event)">
            @for (tab of calendarIntervals; track tab.key) {
                <ds-tab [name]="tab.name">
                    <ng-container *dsTabHeader>
                        <a class="calender-tab-content" [msLink]="tab.url" [vnSpeculativeLink]="tab.url ?? ''">
                            <span>{{ tab.title }}</span>
                            <span>{{ tab.date }}</span>
                        </a>
                    </ng-container>
                </ds-tab>
            }
        </ds-tabs-group>
    }

    @if (fixtureListGrid) {
        @if (calendarIntervals?.length) {
            <div class="sort-filter">
                <div class="filter-button" (click)="competitionTreePopup()">
                    <span>{{ sitecore.globalMessages.CountriesList }}</span>
                    <i class="theme-filter" *msShowInEpcot="true"></i>
                    <i class="theme-preferences" *msShowInEpcot="false"></i>
                </div>
                <div>
                    @if (!fixtureListGrid.disableGroupSorting && fixtureListGrid.sorting !== undefined) {
                        <ms-sort-selector
                            sortingTracking="Competitions"
                            class="grid-sort-selector"
                            [isInverseRequired]="true"
                            [sorting]="fixtureListGrid.sorting"
                            [showRadioInput]="isThemeEpcot"
                            (sortingChange)="sortingChanged($event, fixtureListGrid.id)" />
                    }
                </div>
            </div>
        }
    }

    @if (mediaQuery$ | async) {
        @if (competitions && competitions.length) {
            <ms-fixture-list-menu class="calendar-pills-list" [pills]="competitions" />
        }
    }

    @if (crmPromotions.length) {
        <ms-crm-promotion-container [heightIncreaseAllowed]="true" [showCardShadow]="true" [promotions]="crmPromotions" />
    }

    @if (showBigEventModule && showcaseModuleData) {
        <ms-showcase [moduleData]="showcaseModuleData" />
    }

    @if (tiles.length) {
        <ng-container *msComponentProxy="marqueeComponent" />
    }

    @if (!virtualCompetitionModel && error) {
        <ms-error [message]="error" [severity]="'info'" />
    } @else {
        @if (grid$?.getState() || view === viewType.Standings) {
            <div msScrolledToBottom scrollContext="document" toleranceType="relative" [toleranceValue]="0.5" (scrollAtBottom)="loadMore()">
                <div class="grid-wrapper">
                    <ms-fixture-list-header
                        [sport]="sport"
                        [navigation]="navigation"
                        [showFavoriteToggle]="isFavouriteVisible"
                        [competitionTitle]="competitionTitle">
                        @if (virtualCompetitionModel) {
                            <ms-tournament-groups [model]="virtualCompetitionModel" />
                        }
                    </ms-fixture-list-header>

                    @if (virtualCompetitionModel && error) {
                        <ms-error [message]="error" [severity]="'info'" [links]="false" />
                    } @else {
                        <ng-container *ngTemplateOutlet="grid" />
                    }
                </div>
                <ng-template #grid>
                    <div class="swipe-container" (swiperight)="goBack()">
                        @switch (view) {
                            @case (viewType.Teams) {
                                <ng-container *msComponentProxy="teamPagesCompetitionComponent" />
                            }
                            @case (viewType.Standings) {
                                @if (sport) {
                                    <ms-standings [sport]="sport" [standingsData]="standingsData" />
                                }
                            }
                            @case (viewType.GridList) {
                                @if (fixtureListGrid) {
                                    <ms-grid-list
                                        [model]="fixtureListGrid"
                                        [isOutrightMarket]="isOutrightMarket"
                                        [tracking]="tracking"
                                        [trackCalenderTitle]="trackCalenderTitle" />
                                }
                            }
                            @default {
                                @if (fixtureListGrid) {
                                    <ms-grid
                                        sortingTracking="Competitions"
                                        [model]="fixtureListGrid"
                                        [calendarInfoDisplay]="!!calendarIntervals?.length"
                                        [tracking]="tracking"
                                        [trackCalenderTitle]="trackCalenderTitle"
                                        [ngClass]="{ 'hide-all-markets-link': shouldHideAllMarketsLink }" />
                                }
                            }
                        }
                    </div>
                    @if (hasMore) {
                        <div class="grid-footer ms-active-highlight" (click)="loadMore()">
                            <div [class.spinner-img]="loading">{{ sitecore.event.MoreEvents }}</div>
                        </div>
                    }
                </ng-template>
            </div>
        }
        @if (showEmptySpace) {
            <div class="grid-footer-separator"></div>
        }
    }
</ng-template>
